import { Dialog } from "@headlessui/react";
import { FormBox, ModalFoterBox, ModalHeaderBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { CheckBoxGroup, CheckBoxItem } from "../../components/checkBox/CheckBoxGroup";
import { Modal, ModalProp } from "../../components/modal/Modal"

export type GroupSelectModalProp = {
  companyGroupsValue: CheckBoxItem[];
  groups?: {
    value: any,
    setValue: React.Dispatch<any>,
    onChange:  (e: {
      target: {
        value: any;
      };
    }) => void};
  setState: React.Dispatch<React.SetStateAction<CheckBoxItem[]>>;
  dispButtonFlg?:boolean;
  onSelectCancel?: () => void;
  errorMessage?: string;
}

export const GroupSelectModal = ({
  open,
  toggle,
  closeOnClickOutside,
  groups,
  companyGroupsValue,
  setState,
  dispButtonFlg,
  onSelectCancel,
  errorMessage = '',
}: ModalProp & GroupSelectModalProp) => {

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <div className="px-2 pb-4 sm:p-4">
          <div className="text-center mt-3">
            <ModalHeaderBox title={"グループを選択してください"}/>
          </div>
          {errorMessage !== '' ? (
            <div className="mt-3 text-red-500">
              {errorMessage}
            </div>
          ) : 
            <></>
          }
          <div className="px-2">
            <FormBox>
              <CheckBoxGroup
                children={undefined}
                value={groups}
                name={"group"}
                checkBoxItem={companyGroupsValue}
                setState={setState}
              />
            </FormBox>
          </div>
        </div>
        <ModalFoterBox>
          {dispButtonFlg ? (
            <>
            <Button className="mx-2 mt-1 w-[132px]" outline onClick={() => onSelectCancel? onSelectCancel() : undefined}>
              キャンセル
            </Button>
            <Button className="mt-1 mr-2 w-[132px]" onClick={() => toggle()}>
              選択
            </Button>
            </>
          ):(
            <>
            <Button className="mt-1" onClick={() => toggle()}>
              登録
            </Button>
            </>
          )}
          
        </ModalFoterBox>
      </Dialog.Panel>
    </Modal>
  )
}